/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2021-05-20T10:20:49.721
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	saveRentHouseStateChange,
	getRentHouseStateChangeCreateInit,
	getRentHouseStateChangeEditInit,
	getRentHouseStateChangeView,
	deleteRentHouseStateChange
} from '@api/rentmanage/RentHouseStateChange';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {
		CompoundEntityDictionary: cloneObj(RespCommonDef.CompoundEntityDictionary),
		CompoundEntityDictionaryAdd: cloneObj(RespCommonDef.CompoundEntityDictionary),
	},
	actions: {
		getRentHouseStateChangeCreateInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				getRentHouseStateChangeCreateInit({})
					.then(async res => {
						state.CompoundEntityDictionaryAdd = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getRentHouseStateChangeEditInit({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getRentHouseStateChangeEditInit({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},


		saveRentHouseStateChange({}, RentHouseStateChange) {
			return new Promise((resolve, reject) => {
				saveRentHouseStateChange(RentHouseStateChange)
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
		getRentHouseStateChangeView({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getRentHouseStateChangeView({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
		deleteRentHouseStateChange({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteRentHouseStateChange({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		}
	}
};
